import styled from 'styled-components'

export const Wrapper = styled.svg`
  width: ${({ width }) => width}rem;
  height: ${({ height }) => height}rem;
`
